import {
  Stack,
  Typography,
  FormControl,
  TextField,
  MenuItem,
} from "@mui/material";
import { useMemo, useCallback, ChangeEvent, useEffect } from "react";
import { useGetSuppliesQuery } from "src/api/services/medicationsApi";
import { usePrescribe } from "src/context/PrescribeProvider/usePrescribe";

interface Props {
  pharmacyId: number | null;
}

const MedicalSupplies = ({ pharmacyId }: Props) => {
  const query = useMemo(() => {
    return {
      pharmacy_id: pharmacyId,
      active: true,
    };
  }, [pharmacyId]);

  const { data: supplies = [] } = useGetSuppliesQuery(query);
  const { supplyId, setSupplyId } = usePrescribe();

  const handleSupplies = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setSupplyId(event.target.valueAsNumber);
    },
    [setSupplyId]
  );

  useEffect(() => {
    if (supplyId == null && supplies.length > 0) {
      setSupplyId(supplies[0].id);
    }

    return () => {
      if (supplyId != null) {
        setSupplyId(null);
      }
    };
  }, [setSupplyId, supplies, supplyId]);

  if (supplies.length === 0) return null;

  return (
    <Stack>
      <Typography fontWeight={600}>Medical supplies:</Typography>
      <FormControl sx={{ gap: 1 }}>
        <TextField
          required
          select
          value={supplyId ?? ""}
          onChange={handleSupplies}
          disabled={supplies.length === 1}
        >
          {supplies.map((supply) => (
            <MenuItem key={supply.id} value={supply.id}>
              {supply.name}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </Stack>
  );
};

export default MedicalSupplies;
